// ponytail: copy of app-module-order-page-approve/config.js + the company/contact/product/
// sendattachment endpoints from app-module-order-page-confirmation/config.js, needed here to
// build the invoice PDF (previewData) and email it on approve.
import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Order Approve Collected";
const server = null;
const service = null;
const initDate = new Date();
const initDateFormat = initDate.toISOString().split("T")[0]; // yyyy-mm-dd
const products = setup.setup.thor.products[environment];
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    order: {
      api: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
        endpoints: {
          detail: {
            headers: {
              Authorization: null,
            },
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/orders/{id}",
            url: setup.setup.api.westfield_v1.url[environment] + "/orders/",
            method: "GET",
          },
          approve: {
            headers: {
              Authorization: null,
            },
            doc: "https://tr4ns10.tr4ns.com/Westfield-BulkOrder/orders/{orderId}/cc-approve",
            url: setup.setup.api.westfield_v1.url[environment] + "/orders/",
            method: "GET",
          },
          sendattachment: {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: null,
            },
            doc: "",
            url:
              setup.setup.api.tranxactor_westfield_corp.url[environment] +
              "/mail/invoice",
            method: "POST",
          },
        },
      },
    },
    company: {
      api: {
        headers: {
          "Content-Type": "application/json",
          moduleCode: "WGMB",
        },
        endpoints: {
          detail: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/clients/{id}",
            url: setup.setup.api.westfield_v1.url[environment] + "/clients/",
            method: "GET",
          },
        },
      },
    },
    contacts: {
      api: {
        headers: {
          "Content-Type": "application/json",
          moduleCode: "WGMB",
        },
        endpoints: {
          detail: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/clients/{id}/contacts",
            url: setup.setup.api.westfield_v1.url[environment] + "/clients/",
            method: "GET",
          },
        },
      },
    },
    product: {
      api: {
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
        endpoints: {
          list_Cat1: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/products/?categoryId=1",
            url:
              setup.setup.api.westfield_v1.url[environment] +
              "/products/?categoryId=1",
            method: "GET",
          },
          list_Cat2: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/products/?categoryId=2",
            url:
              setup.setup.api.westfield_v1.url[environment] +
              "/products/?categoryId=2",
            method: "GET",
          },
          list_Cat3: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/products/?categoryId=3",
            url:
              setup.setup.api.westfield_v1.url[environment] +
              "/products/?categoryId=3",
            method: "GET",
          },
          list_Cat4: {
            doc: "http://tr4ns10.tr4ns.com/Westfield-BulkOrder/products/?categoryId=4",
            url:
              setup.setup.api.westfield_v1.url[environment] +
              "/products/?categoryId=5",
            method: "GET",
          },
        },
      },
    },
  },
  routes: {
    label: "Orders Approve Collected",
    prefix: "/orders/approve-click-and-collect/:orderId",
  },
  setup,
  environment,
  products,
};

export default config;
